import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.37868 4.62868C2.94129 4.06607 3.70435 3.75 4.5 3.75H19.5C20.2957 3.75 21.0587 4.06607 21.6213 4.62868C22.1839 5.19129 22.5 5.95435 22.5 6.75V17.25C22.5 18.0456 22.1839 18.8087 21.6213 19.3713C21.0587 19.9339 20.2957 20.25 19.5 20.25H4.5C3.70435 20.25 2.94129 19.9339 2.37868 19.3713C1.81607 18.8087 1.5 18.0456 1.5 17.25V6.75C1.5 5.95435 1.81607 5.19129 2.37868 4.62868ZM3 9.75V17.25C3 17.6478 3.15804 18.0294 3.43934 18.3107C3.72064 18.592 4.10218 18.75 4.5 18.75H19.5C19.8978 18.75 20.2794 18.592 20.5607 18.3107C20.842 18.0294 21 17.6478 21 17.25V9.75H3ZM21 7.5H3V6.75C3 6.35218 3.15804 5.97064 3.43934 5.68934C3.72064 5.40804 4.10218 5.25 4.5 5.25H19.5C19.8978 5.25 20.2794 5.40804 20.5607 5.68934C20.842 5.97064 21 6.35218 21 6.75V7.5ZM4.5 14.25C4.5 13.8358 4.83579 13.5 5.25 13.5H11.25C11.6642 13.5 12 13.8358 12 14.25C12 14.6642 11.6642 15 11.25 15H5.25C4.83579 15 4.5 14.6642 4.5 14.25ZM4.5 16.5C4.5 16.0858 4.83579 15.75 5.25 15.75H8.25C8.66421 15.75 9 16.0858 9 16.5C9 16.9142 8.66421 17.25 8.25 17.25H5.25C4.83579 17.25 4.5 16.9142 4.5 16.5Z"
        fill={colorValue}
      />
    </svg>
  );
};
